// extracted by mini-css-extract-plugin
module.exports = {"ClientDetails":"ClientDetails_ClientDetails__2CoRP"};